import React, { useEffect, useState } from 'react'
import { approveOrRejectDailyLabourReportApi, getDailyLabourReportApi } from '../../../utils/ApiEndpointFunctions';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { MONTHS } from '../../../utils/constant';
import Spinwheel from '../../../components/common/Spinwheel';
import { useUserContext } from '../../../context/userContext';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../../components/modal/ConfirmationModal';
import Filter from '../../../components/modal/Filter';
import { useFormik } from 'formik';
import moment from 'moment/moment';
import ReactPaginate from 'react-paginate';
import StatusModal from '../../../components/modal/StatusModal';
import { getLocalizationStatus } from '../../../utils/HelperFuncitons';

export default function ViewDLRTable(props) {
  const [dlr, setDpl] = useState([])
  const [loading, setLoading] = useState({ dlr: true })
  const navigate = useNavigate();
  const { userDetails,langPreference } = useUserContext();
  const isInspector = (userDetails?.roleId?.type || userDetails?.roleId?.name?.toLowerCase()?.replace(/[^a-z0-9]/g, "")) === "inspector";
  const confirmModalId = "conFirmModalID"
  const filterModalId = "filterModalID"
  const statusModalId = "statusModal"
  const [selectDlr, setSelectDlr] = useState({id:null,dlrNo:null,status:null});
  const limit = 10;
  const [page, setPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [confirmMessage,setConfirmMessage] = useState("")
  // let [selectedPage, setSelectedPage] = useState(searchParams.get("page") == null ? 1 : searchParams.get("page"));
  const location = useLocation()

  const [totalCount, setTotalCount] = useState(null);

  const getAllDprList = async (filterReset) => {
    setLoading({ ...loading, dlr: true });
    let filter = filterReset === "reset" ? ["", "", "", "", "", ""] : [
      filterFormik.values?.uniqueItemId,
      `${filterFormik.values?.to ? new Date(filterFormik.values?.to).getTime() + "-" : ""}${filterFormik.values?.from ? new Date(filterFormik.values?.from).getTime() : ""}`,
      filterFormik.values?.number,
      filterFormik.values?.status,
      filterFormik.values?.vendorId,
    ];
    try {
      const page = searchParams.get("page") || 1
      const res = await getDailyLabourReportApi(...filter, limit, page);
      if (res.status === 200) {
        setDpl(res.data?.data?.dlr);
        setTotalCount(res.data?.data?.totalCount);
        setPage(Math.ceil(res.data?.data?.totalCount / limit));
      }
    } catch (error) {
      console.log(error)
    }
    setLoading({ ...loading, dlr: false });
  }

  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;

    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", currentPage);

    if (newParams.has("tab")) {
      newParams.set("tab", newParams.get("tab"));
    }

    setSearchParams(newParams);
  };


  const handleApproval = async () => {
    try {
      const res = await approveOrRejectDailyLabourReportApi({ id: selectDlr.id,status:selectDlr?.status })
      if (res.status === 200) {
        setConfirmMessage(res.data?.message || `DLR ${selectDlr.dlrNo || ""} is successfully  ${selectDlr?.status}.`)
        document.getElementById(confirmModalId).click()
        document.getElementById("statusModalBtn").click()
        getAllDprList()
      }
    } catch (error) {
      console.log(error)
      toast.error("something went wrong");
    }
  }


  const handleFilterPo = () => {
    if (searchParams.get('page') == 1) {
      getAllDprList()
    } else {
      setSearchParams({ "page": 1 })
    }
  }

  const filterFormik = useFormik({
    initialValues: {
      Item: "",
      hsnCode: "",
      number: "",
      status: "",
      vendorName: "",
      to: "",
      from: "",
      itemId:""
    }
  })


  useEffect(() => {
      getAllDprList()
  },[searchParams.get('page')])


  return (
    <>

      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">

              {props.type !== "dashboard" && <div className="dash-nav1">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0 font-blue">{langPreference?.daily_labour_report || "Daily Labour Report"}</h3>
                  <div className='d-flex gap-2'>
                  {userDetails?.roleId?.permission?.includes("dlrWrite") && <button onClick={() => { navigate("/dlr/add"); }} className="create-order mb-3"> {langPreference?.create_new_dlr || "Create DLR"}</button>}
                  {!isInspector && userDetails?.roleId?.permission?.includes("dlrRead") && <button onClick={() => { navigate("/dlr/report"); }} className="create-order mb-3"> {langPreference?.report || "Report"}</button>}
                  </div>

                </div>
              </div>}
              <div className="d-flex justify-content-end align-items-end">
                <div className="d-flex align-items-center justify-content-end">
                  <div className="dropdown">
                    <button className="btn btn-dark me-2" type="button" disabled={!Object.values(filterFormik?.values).filter(Boolean).length} onClick={() => { filterFormik.resetForm(); getAllDprList("reset") }} >
                    {langPreference?.reset_filter || "Reset filter"}
                    </button>
                    <button className="btn filter  dropdown-toggle" type="button" data-bs-toggle="modal" data-bs-target={`#${filterModalId}`}  >
                      <i className="bi bi-funnel me-2"></i>{langPreference?.filter || "Filter"}
                    </button>
                  </div>
                </div>
              </div>
              {/* <!-- table --> */}
              <div className="table-responsive" style={{ overflowX: "inherit" }}>
                <table className="table d-table mt-4">
                  <thead>
                    <tr>
                      <th scope="col">{langPreference?.dlr_number || "DLR NUMBER"}</th>
                      <th scope="col">{langPreference?.item_counts || "ITEMS COUNT."}</th>
                      <th scope="col">{langPreference?.no_of_labour || "No of Labour"}</th>
                      <th scope="col">{langPreference?.technical || "Technical"}</th>
                      <th scope="col">{langPreference?.non_technical || "Non Technical"}</th>
                      <th scope="col">{langPreference?.created_date || "CREATED DATE"}</th>
                      <th scope="col">{langPreference?.status || "STATUS"}</th>
                      <th scope="col">{langPreference?.action || "ACTION"}</th>
                    </tr>
                  </thead>
                  {
                    loading.dlr ?
                      <tbody >
                        <tr>
                          <td colSpan={12}>
                            <div className="d-flex justify-content-center">
                              <Spinwheel />
                            </div>
                          </td>
                        </tr>
                      </tbody> :
                     
                        <tbody>
                          {dlr?.length > 0 ? dlr?.map((ele, index) => {
                            return (
                              <tr key={index}>
                                <td>{ele?.dlrNumber}</td>
                                <td>{ele?.items?.length}</td>
                                <td>{ele?.totalLabour}</td>
                                <td>{ele?.totalTechnical}</td>
                                <td>{ele?.totalNonTechnical}</td>
                                <td>{moment(ele?.createDate).format("DD/MM/YYYY")}</td>
                                <td><button className={` cursor-text text-capitalize ${ele?.status?.toLowerCase() == "approved" ? "approve" : (ele?.status?.toLowerCase() == "rejected" ? "reject" : "sbm")} `}>{getLocalizationStatus(langPreference,ele?.status)}</button></td>
                                <td>
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div>
                                      {userDetails?.roleId?.permission.includes("poReject") && ele?.status?.toLowerCase() !== "reject" && <button className="reject">Reject</button>}
                                    </div>
                                    <div>
                                      <div className="dropdown">
                                        <button className="dots dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots-vertical"></i></button>
                                        <ul className="dropdown-menu">
                                          {userDetails?.roleId?.permission.includes("dlrRead") && <li className='dropdown-item' onClick={() => { navigate(`/dlr/view/${ele?._id}`) }} >{langPreference?.view || "View"}</li>}
                                          {(((userDetails?.roleId?.permission.includes("dlrUpdate")) && ele?.status?.toLowerCase() != "approved" && ele?.status?.toLowerCase() != "rejected")) && <li className='dropdown-item' onClick={() => { navigate(`/dlr/update/${ele?._id}`) }} >{langPreference?.edit || "Edit"}</li>}
                                          {userDetails?.roleId?.permission.includes("dlrApprove") && ele?.status?.toLowerCase() != "created" && ele?.status?.toLowerCase() != "approved" && ele?.status?.toLowerCase() != "rejected" &&
                                            <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => { setSelectDlr({id:ele?._id,dlrNo:ele?.dprNumber,status:"approved"}) }} >{langPreference?.approve || "Approve"}</li>}
                                            {userDetails?.roleId?.permission.includes("dlrReject") && ele?.status?.toLowerCase() != "created" && ele?.status?.toLowerCase() != "rejected" && <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => { setSelectDlr({id:ele?._id,dlrNo:ele?.dprNumber,status:"rejected"}) }} >{langPreference?.reject || "Reject"}</li>}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>)
                          }) : <tr className='text-center'>
                            <td colSpan="12">
                              <h1>{langPreference?.data_not_found || "Data Not Found"}</h1>
                            </td>
                          </tr>}
                        </tbody>}
                </table>
              </div>
              {totalCount > limit ? (
                <div className="d-flex justify-content-center">
                  <ReactPaginate
                    nextLabel={`${langPreference?.next_page || "Next"} >`}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={page}
                    previousLabel={`< ${langPreference?.previous_page || "Previous"}>`}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName={"active"}
                    forcePage={searchParams.get('page')? Number(searchParams.get('page'))-1 : 0}
                  />
                </div>
              ) : (
                ""
              )}
              <ConfirmationModal modalId={confirmModalId} handleConfirm={handleApproval} message={selectDlr?.status=="approved" ? langPreference?.approve_confirmation : langPreference?.confirm_reject || <>Are you sure you want to <br /> {selectDlr?.status=="approved" ? "approve" : "reject"} ?</>} />
              <Filter modalId={filterModalId} formik={filterFormik} clickHandler={handleFilterPo} filterType={"dlr"} isSiteItem={true}/>
              <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`}/>
              <StatusModal 
                modalId={statusModalId}
                message={confirmMessage}
              />

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
